// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-form__label {
  margin-bottom: 2rem;
  font-size: 1.5rem;
  text-align: center;
}
.upload-form__inputs {
  margin: 2rem 0 1rem 0;
}
.upload-form__controls {
  text-align: center;
}
.upload-form__duration > span {
  font-weight: 600;
}
.upload-form__unknown-duration {
  font-style: italic;
}
.upload-form .ant-form-item-explain-error {
  font-size: 13px;
  width: 200%;
}
`, "",{"version":3,"sources":["webpack://./src/components/FileSplitterForm/style.less"],"names":[],"mappings":"AACE;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,qBAAA;AADJ;AAIE;EACE,kBAAA;AAFJ;AAIE;EACE,gBAAA;AAFJ;AAIE;EACE,kBAAA;AAFJ;AAhBA;EAqBI,eAAA;EACA,WAAA;AAFJ","sourcesContent":[".upload-form {\n  &__label {\n    margin-bottom: 2rem;\n    font-size: 1.5rem;\n    text-align: center;\n  }\n  \n  &__inputs {\n    margin: 2rem 0 1rem 0;\n  }\n\n  &__controls {\n    text-align: center;\n  }\n  &__duration > span {\n    font-weight: 600;\n  }\n  &__unknown-duration {\n    font-style: italic;\n  }\n  .ant-form-item-explain-error {\n    font-size: 13px;\n    width: 200%;\n  }\n}\n@display-sm: ~\"only screen and (min-width:576px) \";@display-md: ~\"only screen and (min-width:768px)\";@display-lg: ~\"only screen and (min-width:992px)\";@display-xl: ~\"only screen and (min-width:1200px)\";@display-xxl: ~\"only screen and (min-width:1680px)\";@font-family: 'Open Sans', sans-serif;@font-size-base: 15px;@font-size-lg: @font-size-base + 2px;@font-size-sm: @font-size-base - 2px;@white: #fff;@beey-orange: #f3ab58;@beey-orange-darken: #f29f40;@beey-yellow-light: #fef9e9;@beey-blue: #698efc;@beey-blue-light: #82a1fc;@primary-color: @beey-orange-darken;@link-color: @beey-orange-darken;@text-color: #444;@text-color-secondary: #888;@heading-color: #303030;@header-height: 5rem;@header-height-sm: 3rem;@header-line-height: 2rem;@playback-height: 65px;@color-error: #95190c;@text-primary-disabled: #999;@text-secondary: #000000;@text-secondary-dimmed: #666;@text-heading1: #000000;@font-weight-semi-bold: 600;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
